import styled from "styled-components";
import {SectionWrapper} from "shared/Styles/Wrappers";
import CircleImg from "assets/images/circle.svg";

export const Container = styled.div`
    padding: 72px 0 124px 0;
    background-color: ${({color}) => (color ? color : "#fff")};
    position: relative;
    z-index: 2;
    color: ${({color}) => (color ? "#fff" : "#000 ")};
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding: 72px 0;
    }
`;

export const TechnologiesItem = styled.div`
    padding: 10px 40px;
    border: 2px solid #e4e4e4;
    border-radius: 5px;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 18px;

    &:not(:last-child) {
        margin-right: 18px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding: 8px 30px;
        font-size: 1.4rem;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding: 6px 18px;
        font-size: 1.2rem;
        border: 1px solid #e4e4e4;

        &:not(:last-child) {
            margin-right: 12px;
        }
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone}) {
        width: calc(50% - 6px);
        text-align: center;
        padding: 8px;
        &:not(:last-child) {
            margin-right: 0px;
        }

        &:not(:nth-child(2n)) {
            margin-right: 12px;
        }
    }
`;

export const TechnologiesWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 72px 0;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        margin: 48px 0;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        margin: 36px 0 24px 0;
    }
`;

export const Title = styled.h2`
    font-size: 6rem;
    line-height: 1.1;
    font-weight: 800;
    max-width: 800px;
    width: 100%;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        font-size: 4.2rem;
        line-height: 1.1;
    }
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.laptop_small}) {
    }
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet_big}) {
        font-size: 3.4rem;
    }
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.phone_big}) and (orientation: portrait) {
        font-size: 3rem;
        line-height: 1.2;
    }

    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet}) and (orientation: landscape) {
        font-size: 2.8rem;
    }
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.phone_big}) and (orientation: landscape) {
        font-size: 2.4rem;
    }
`;

export const Wrapper = styled(SectionWrapper)``;

export const List = styled.ul`
    width: 50%;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        width: 100%;
        margin-top: 24px;
    }
`;

export const ListItem = styled.li`
    font-weight: 700;
    position: relative;
    padding-left: 30px;

    &:not(:last-child) {
        margin-bottom: 24px;
    }

    &:before {
        content: "";
        display: block;
        position: absolute;
        top: 5px;
        left: 0;
        width: 8px;
        height: 8px;
        background-image: url(${CircleImg});
        background-repeat: no-repeat;
        background-position: center;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        font-size: 1.4rem;
        &:before {
            font-size: 4px;
        }

        &:not(:last-child) {
            margin-bottom: 18px;
        }
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone_big}) {
        padding-left: 24px;
    }
`;

export const Text = styled.p`
    width: 50%;
    padding-right: 124px;
    font-size: 1.6rem;
    font-weight: 300;
    line-height: 2;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding-right: 72px;
        font-size: 1.4rem;
    }
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet_big}) {
        font-size: 1.2rem;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding-right: 0;
        width: 100%;
    }
`;

export const TextBox = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const SmallTitle = styled.h3`
    width: 100%;
    font-size: 4rem;
    font-weight: 800;
    margin-bottom: 34px;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        font-size: 3rem;
        margin-bottom: 24px;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        font-size: 2rem;
    }
`;

export const ImageWrapper = styled.div`
    width: 50%;
    max-width: ${({width}) => (width ? width : 550)}px;;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        width: 100%;
        margin-top: 36px;
        margin-left: auto;
        margin-right: auto;
    }
`;
